import { Navigate, useParams } from 'react-router-dom'
import { DEVELOPER_PLATFORM_PATH } from '@mysaiva/core/developer-platform'

/**
 * Keeps links to the retired hand-written docs working (PR #75):
 * `docs/resources/:resourceId` maps 1:1 onto the OpenAPI API Reference,
 * whose endpoint ids keep the old slugs (`SLUG_OVERRIDES` in
 * `docs/openapi/fromOpenApi.ts`); `docs/reference/*` sections have no
 * counterpart, so they open the API Reference itself. An unknown id lands on
 * the first endpoint via `ApiOpenApiPreviewPage`.
 */
export function LegacyDocsRedirect() {
  const { resourceId } = useParams<{ resourceId?: string }>()
  const target = `${DEVELOPER_PLATFORM_PATH}/docs/openapi${resourceId ? `/${resourceId}` : ''}`
  return <Navigate to={target} replace />
}
